import React from 'react';
import type { CrudAddModalProps } from '../crud/CrudTable';
import type { ProductEventFragment } from '../../graphql/graphql';
import { useEventService } from '../../services/EventService';
import AddProductAssociationModal from '../shared/AddProductAssociationModal';

export type AddProductEventModalProps = CrudAddModalProps<ProductEventFragment, ProductEventFragment> & {
	eventId: string;
};

export default function AddProductEventModal(props: AddProductEventModalProps) {
	const { eventId, onCreated, ...modalProps } = props;
	const eventService = useEventService();

	const handleCreated = (created: ProductEventFragment | ProductEventFragment[]) => {
		if (Array.isArray(created)) {
			created.forEach((createdItem) => onCreated(createdItem));
			return;
		}

		onCreated(created);
	};

	const handleAddProduct = async (entityId: string, productIds: string | string[]) => {
		if (Array.isArray(productIds)) {
			return await Promise.all(
				productIds.map(async (productId) => {
					return await eventService.addProductEvent({
						event: {
							connect: {
								id: entityId,
							},
						},
						product: {
							connect: {
								id: productId,
							},
						},
					});
				}),
			);
		}

		return await eventService.addProductEvent({
			event: {
				connect: {
					id: entityId,
				},
			},
			product: {
				connect: {
					id: productIds,
				},
			},
		});
	};

	return (
		<AddProductAssociationModal
			{...modalProps}
			entityId={eventId}
			onAddProduct={handleAddProduct}
			onCreated={handleCreated}
			errorMessage="Failed to add product to event"
		/>
	);
}
